/**
 * synchronizes x-scroll position of parent to the fixed element scroll position
 * @param {Element} parent
 * @param {HTMLAllCollection} elements
 */
export default function syncXScroll(parent, elements) {
  elements.forEach((element) => {
    const fixedItem = element;
    fixedItem.scrollLeft = parent.scrollLeft;
  });
}
